export enum CustomEventType {
  AIS_IMPORT_FILE_CHANGE = 'ais-import-file-change',
}
